import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';
import {
    initialReservationTypes,
    setAmenities,
    setAmenitiesV2,
    setReservationTypes,
} from './filters-utils';

const getSearchId = state => state.searchRequest.id;
const getIsMonthly = state => state.searchRequest.monthly;
const getAllSpots = state => state.spots.data;
const getCurrentFilters = state => state.filters;
const getAllReservationTypes = state => state.filters.reservationTypes;
let currentSearchId = null;

/* V2-CLEANUP
Delete this getAmenities function when Search V2 Integration is complete.
getAmenitiesV2 can be renamed to setAmenities.
This is used on Search for Transient, Monthly, and Event verticals
*/
export const getAmenities = createSelector(
    [getSearchId, getIsMonthly, getAllSpots, getCurrentFilters],
    (searchId, isMonthly, spots, filters) => {
        if (!spots.length) {
            return {};
        }

        const isNewSearch = currentSearchId !== searchId;

        if (isNewSearch) {
            currentSearchId = searchId;
        }

        return setAmenities({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            rateType: isMonthly ? 'monthly_rates' : 'hourly_rates',
            isNewSearch,
        });
    }
);

export const getAmenitiesV2 = createSelector(
    [getAllSpots, getCurrentFilters],
    (spots, filters) => {
        if (!spots.length) {
            return {};
        }

        return setAmenitiesV2({
            spots,
            filteredSpots: SpotUtils.filterV2(spots, filters),
        });
    }
);

export const getReservationTypes = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllReservationTypes],
    (isMonthly, spots, filters, reservationTypes) => {
        if (!spots.length || !isMonthly) {
            return initialReservationTypes;
        }

        return setReservationTypes({
            spots: SpotUtils.filter(spots, filters, isMonthly),
            reservationTypes,
        });
    }
);
